<div
  class="disclaimer"
  [class]="color"
>
  <div>
    <i [className]="'icon ic-md ' + icon" [hidden]="!icon"></i>
  </div>

  @if (content) {
    <span class="text" [innerHtml]="content"></span>
  } @else {
    <span class="text"><ng-content/></span>
  }
</div>
